export type AllocationOption = "conservative" | "moderate" | "aggressive";

const EVENT_NAME = "wealth-builder-allocation-change";

let current: AllocationOption = "moderate";

export function getCurrentAllocation(): AllocationOption {
    return current;
}

export function setCurrentAllocation(option: AllocationOption): void {
    current = option;
    // Drive the legacy .connected-tabs DOM directly here so the page reacts
    // even when TargetAllocationBlock is still below the fold and hasn't
    // lazy-mounted (the sticky-nav switcher is loaded immediately).
    switchConnectedTabs(option);
    window.dispatchEvent(new CustomEvent<AllocationOption>(EVENT_NAME, { detail: option }));
}

export function subscribeToAllocation(handler: (option: AllocationOption) => void): () => void {
    const listener = (e: Event) => handler((e as CustomEvent<AllocationOption>).detail);
    window.addEventListener(EVENT_NAME, listener);
    return () => window.removeEventListener(EVENT_NAME, listener);
}

export function switchConnectedTabs(option: AllocationOption): void {
    const tabLabel = option.charAt(0).toUpperCase() + option.slice(1);

    document.querySelectorAll<HTMLElement>(".connected-tabs").forEach((container) => {
        container.querySelectorAll<HTMLElement>(".connected-tabs-inner").forEach((inner) => {
            const navItems = inner.querySelectorAll<HTMLElement>(".tab-nav__list-item");
            let matchedTabId: string | null = null;

            navItems.forEach((navItem) => {
                const span = navItem.querySelector("span");
                const text = span?.textContent?.trim().toLowerCase() ?? "";
                if (text === tabLabel.toLowerCase()) {
                    matchedTabId = navItem.getAttribute("data-tab");
                }
            });

            if (!matchedTabId) return;

            navItems.forEach((navItem) => {
                const link = navItem.querySelector(".tab-nav__link");
                if (navItem.getAttribute("data-tab") === matchedTabId) {
                    navItem.classList.add("active");
                    link?.classList.add("active");
                } else {
                    navItem.classList.remove("active");
                    link?.classList.remove("active");
                }
            });

            const contents = inner.querySelectorAll<HTMLElement>(".connected-tabs-inner-content");
            contents.forEach((content) => {
                if (content.getAttribute("data-tab-content") === matchedTabId) {
                    content.classList.remove("hidden");
                } else {
                    content.classList.add("hidden");
                }
            });
        });
    });
}
